define('collections/calendar/session/exercise/exercises',[
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/api',
    // collections
    'collections/calendar/session/exercise/weight/weeks',
    // Pull in the Model module from above
    'models/calendar/session/exercise/exercise'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // services
    API,
    // collections
    CWeightWeeks,
    // model
    MExercise
) {

    var CExercises = Backbone.Collection.extend({
        model: MExercise,

        constructor: function(models, options) {
            Backbone.Collection.apply(this, arguments);
            this.updatePositions();
        },

        initialize: function(models, opt) {
            this.listenTo(this, 'update reset', this.updatePositions);
        },

        getAllWeekDone: function(weekIndex) {
            var weeks = [];
            this.each(function(model) {
                weeks.push(model.getWeekDone(weekIndex));
            });
            return weeks;
        },

        setLoadUnit: function() {
            this.each(function(model) {
                if (model.isWeight()) {
                    model.getWeeks().each(function(model) {
                        model.setLoadUnit();
                    });
                }
            });
        },

        pushAnimation: function(animations, options) {
            options = options || {};
            if (!_.isArray(animations)) animations = [animations];

            var newExercises = [];
            _.each(animations, function(animation) {
                newExercises.push({
                    _animation: animation.attributes,
                    animatedExercise: animation.id
                });
            });
            var models = this.push(newExercises, options);

            if (options.silent) {
                this.updatePositions();
            }
            return models;
        },

        updatePositions: function() {
            var index = 0;
            this.each(function(exercise) {
                exercise.set({ index: index++ });
            });
        },

        onWeekChange: function(model, numWeeks, options) {
            if (this.sessionId === model.id) {
                this.each(function(exercise) {
                    // exercise.trigger("change:num_weeks", numWeeks);
                    exercise.onNumWeekChange(model, numWeeks, options);
                });
            }
        },

        onNewModel: function(model) {
            if (!model.id) {
                model.setId(_.uniqueId('exercise'));
            }
        },

        /**
         * Override the default collection's 'move' method to update the
         * position number of each model and to adjust the links between them.
         */
        move: function(src, dest, options) {
            if (src === dest) {
                return this;
            }
            // this.at(src).toggleLink(false);
            // if (src - 1 >= 0) this.at(src - 1).toggleLink(false);

            CExercises.__super__.move.call(this, src, dest, options);
            this.updatePositions();
            // if (dest - 1 >= 0) this.at(dest - 1).toggleLink(false);

            return this;
        },

    });

    return CExercises;
});

